
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";

interface MarkdownRendererProps {
  content: string;
  type?: "system" | "user";
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content, type = "system" }) => {
  console.log('📝 MARKDOWN-RENDERER: Rendering content with length:', content.length);
  console.log('📝 MARKDOWN-RENDERER: Content preview:', content.substring(0, 200));
  console.log('📝 MARKDOWN-RENDERER: Newline check:', content.includes('\n') ? 'Has newlines' : 'No newlines');
  
  return (
    <ReactMarkdown
      remarkPlugins={[remarkBreaks]}
      components={{
        a: ({ ...props }) => (
          <a 
            {...props} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-primary hover:opacity-80 underline"
          />
        ),
        p: ({ ...props }) => (
          <p {...props} className="mb-4 last:mb-0 leading-relaxed text-foreground" />
        ),
        ul: ({ ...props }) => (
          <ul {...props} className="list-disc pl-6 mb-4 space-y-2 text-foreground" />
        ),
        ol: ({ ...props }) => (
          <ol {...props} className="list-decimal pl-6 mb-4 space-y-2 text-foreground" />
        ),
        li: ({ ...props }) => (
          <li {...props} className="mb-1 leading-relaxed text-foreground" />
        ),
        h1: ({ ...props }) => (
          <h1 {...props} className="text-2xl font-semibold mb-4 mt-6 first:mt-0 text-foreground" />
        ),
        h2: ({ ...props }) => (
          <h2 {...props} className="text-xl font-semibold mb-3 mt-5 first:mt-0 text-foreground" />
        ),
        h3: ({ ...props }) => (
          <h3 {...props} className="text-lg font-medium mb-2 mt-4 first:mt-0 text-foreground" />
        ),
        strong: ({ ...props }) => (
          <strong {...props} className="font-semibold text-foreground" />
        ),
        em: ({ ...props }) => (
          <em {...props} className="italic" />
        ),
        blockquote: ({ ...props }) => (
          <blockquote {...props} className="border-l-4 border-primary pl-4 my-4 italic bg-muted py-2" />
        ),
        hr: ({ ...props }) => (
          <hr {...props} className="my-6 border-border" />
        ),
        code: ({ ...props }) => (
          <code {...props} className="bg-muted px-1 py-0.5 rounded text-sm font-mono" />
        ),
        pre: ({ ...props }) => (
          <pre {...props} className="bg-muted p-3 rounded mb-4 overflow-x-auto" />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
};

export default MarkdownRenderer;
